import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Button, Dropdown, Menu, Badge } from 'antd';
import { CustomTable, Text, useText } from '@src/components';
import { DashOutlined } from '@ant-design/icons';
import AddVehicleModal from './AddVehicleModal';
import VehicleManagementDetailCancelDeviceModal from './VehicleManagementDetailCancelDeviceModal';
import VehicleManagementDetailCancelDeviceRenewModal from './VehicleManagementDetailCancelDeviceRenewModal';
import PO from '@src/assets/icons/ticketcar/4.svg';
import TOTAL from '@src/assets/icons/ticketcar/41.svg';
import BP from '@src/assets/icons/ticketcar/42.svg';
import '@src/styles/addNewCar/addCarOrderSummary.scss';
import { useHistory } from 'react-router-dom';
import { useMediaQuery } from '@src/hooks/useMediaQuery';
import { useSelector } from 'react-redux';

const getIconComponent = (providerType) => {
  switch (providerType) {
    case 4:
      return PO;
    case 41:
      return TOTAL;
    case 42:
      return BP;
    default:
      return null;
  }
};

const VehicleDeviceOperations = ({
  vehicleListDetailDeviceTypes,
  vehicleManagmentItem,
  deviceTypeId,
  detailListCount,
}) => {
  const [vehicleDetailDeviceTypes, setVehicleDetailDeviceTypes] = useState([]);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isModalCancelDeviceVisible, setIsModalCancelDeviceVisible] = useState(false);
  const [isModalCancelDeviceRenewVisible, setIsModalCancelDeviceRenewVisible] = useState(false);
  const [deviceStatus, setDeviceStatus] = useState(null);
  const [selectedVehicleDetailId, setSelectedVehicleDetailId] = useState(null);
  const [selectedOnlyDelete, setSelectedOnlyDelete] = useState(false);
  const history = useHistory();
  const isMobil = useMediaQuery({ query: '(max-width: 999px)' });
  const addNewDeviceText = useText('addNewDevice');
  const temporarilyStopFuelPurchaseText = useText('temporarilyStopFuelPurchase');
  const openFuelPurchaseText = useText('openFuelPurchase2');
  const activeText = useText('active2');
  const passiveText = useText('passive');

  const { isAdmin } = useSelector((state) => state.auth);

  const intialVehicleListDetailDeviceTypes = () => {
    let dontShowRing = false;
    if (
      vehicleListDetailDeviceTypes?.filter((item) => item.device?.includes('UTTS')).length > 0 &&
      vehicleListDetailDeviceTypes?.filter((item) => item.device === 'Akıllı Halka').length > 0
    ) {
      dontShowRing = true;
    }
    const dataSourceWithId = dontShowRing
      ? vehicleListDetailDeviceTypes
          .filter((item) => item.device !== 'Akıllı Halka')
          ?.map((item, index) => ({
            ...item,
            id: index + 1,
          }))
      : vehicleListDetailDeviceTypes.map((item, index) => ({
          ...item,
          id: index + 1,
        }));
    setVehicleDetailDeviceTypes(dataSourceWithId);
  };

  useEffect(() => {
    if (vehicleListDetailDeviceTypes && vehicleListDetailDeviceTypes.length > 0) {
      intialVehicleListDetailDeviceTypes();
    }
  }, [vehicleListDetailDeviceTypes]);

  const showCancelDeviceModal = (vehicleDetailId, status) => {
    setSelectedVehicleDetailId(vehicleDetailId);
    setDeviceStatus(status);
    setIsModalCancelDeviceVisible(true);
  };

  const showCancelDeviceRenewModal = (vehicleDetailId) => {
    setSelectedVehicleDetailId(vehicleDetailId);
    setIsModalCancelDeviceRenewVisible(true);
  };

  const columns = [
    {
      title: '#',
      dataIndex: 'id',
      key: 'id',
      fixed: 'left',
      align: 'center',
      width: isMobil ? 20 : 40,
      height: 50,
    },
    {
      title: <Text t="devices" />,
      dataIndex: 'device',
      key: 'device',
      align: 'left',
      width: isMobil ? 88 : 90,
      height: 50,
    },
    {
      title: <Text t="provider2" />,
      dataIndex: 'provider',
      key: 'provider',
      align: 'left',
      width: isMobil ? 86 : 90,
      height: 50,
      render: (_, record) => {
        const vouId = record.providerType;
        const IconComponent = getIconComponent(vouId);

        return (
          <div style={{ display: 'flex', alignItems: 'center' }}>
            {IconComponent && (
              <img
                src={IconComponent}
                alt={record.provider}
                style={{ width: 24, height: 24, marginRight: 8 }}
              />
            )}
            <p style={{ marginTop: 15 }}>{record.provider}</p>
          </div>
        );
      },
    },
    {
      title: <Text t={useText('status')} />,
      dataIndex: 'status',
      key: 'status',
      align: 'left',
      width: isMobil ? 82 : 90,
      height: 50,
      render: (status) => (
        <span style={{ display: 'flex', alignItems: 'center' }}>
          {status === 'Aktif' ? activeText : passiveText}
          <Badge color={status === 'Aktif' ? 'green' : 'red'} style={{ marginLeft: 8 }} />
        </span>
      ),
    },
    {
      title: <Text t="transactions2" />,
      key: 'actions',
      align: 'left',
      width: 80,
      height: 50,
      render: (text, record) => {
        const menu = (
          <Menu className="custom-dropdown-menu">
            <Menu.Item
              key="1"
              className="custom-dropdown-item"
              onClick={() => showCancelDeviceModal(record.vehicleDetailId, record.status)}
            >
              {record.status === 'Aktif' ? temporarilyStopFuelPurchaseText : openFuelPurchaseText}
            </Menu.Item>
            {deviceTypeId !== 17 && (
              <Menu.Item
                key="2"
                className="custom-dropdown-item"
                onClick={() => showCancelDeviceRenewModal(record.vehicleDetailId)}
              >
                <Text t="deviceIsFaultyCancelAndRenew" />
              </Menu.Item>
            )}
            <Menu.Item
              key="3"
              className="custom-dropdown-item"
              onClick={() => {
                setSelectedOnlyDelete(true);
                showCancelDeviceRenewModal(record.vehicleDetailId);
              }}
            >
              <Text t="permanentlyCancel" />
            </Menu.Item>
          </Menu>
        );

        return (
          <Dropdown overlay={menu} trigger={['click']}>
            <Button
              type="text"
              icon={<DashOutlined />}
              style={{
                borderRadius: '50%',
                padding: '6px',
                backgroundColor: '#f1f5f9',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: 'auto',
                height: 'auto',
              }}
            />
          </Dropdown>
        );
      },
    },
  ];

  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleCancelDeviceOk = () => {
    setIsModalCancelDeviceVisible(false);
  };

  const handleCancelDeviceRenewOk = () => {
    if (selectedOnlyDelete || detailListCount < 2) {
      history.push(
        isAdmin ? '/admin/ticket-car/management-car-processes' : '/ticket-car/vehicle-management',
      );
    }
    setSelectedOnlyDelete(false);
    setIsModalCancelDeviceRenewVisible(false);
  };

  const handleOk = () => {
    setIsModalVisible(false);
    // Ekstra işlemler eklenebilir
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const handleDeviceCancel = () => {
    setIsModalCancelDeviceVisible(false);
  };

  const handleDeviceRenewCancel = () => {
    setSelectedOnlyDelete(false);
    setIsModalCancelDeviceRenewVisible(false);
  };

  return (
    <div data-testid="add-new-car-order-summary-component">
      <div className="add-new-car-order-summary">
        <Row justify={isMobil ? 'center' : 'end'} align="middle" style={{ marginBottom: '16px' }}>
          <Col>
            <Button
              type="text"
              style={{
                fontSize: '14px',
                fontWeight: 'bold',
                textDecoration: 'underline',
                color: isMobil ? '#FFF' : '#000',
                marginTop: '15px',
                backgroundColor: isMobil ? '#3c4655' : 'transparent',
                borderRadius: 6,
              }}
              onClick={showModal}
            >
              {`+ ${addNewDeviceText}`}
            </Button>
          </Col>
        </Row>
        <CustomTable
          pagination={false}
          dataSource={vehicleDetailDeviceTypes}
          columns={columns}
          className="babs-list-table"
          rowKey={(record) => `add-new-car-order-summary-list-${record?.id}`}
        />
        <AddVehicleModal
          isVisible={isModalVisible}
          handleOk={handleOk}
          handleCancel={handleCancel}
          vehicleId={vehicleManagmentItem.vehicleId}
          vehicleListDetailDeviceTypes={vehicleListDetailDeviceTypes}
        />
        <VehicleManagementDetailCancelDeviceModal
          isVisible={isModalCancelDeviceVisible}
          handleOk={handleCancelDeviceOk}
          handleCancel={handleDeviceCancel}
          vehicleId={vehicleManagmentItem.vehicleId}
          plate={vehicleManagmentItem.plate}
          vehicleDetailId={selectedVehicleDetailId}
          providerType={vehicleManagmentItem.providerType}
          status={deviceStatus}
        />
        <VehicleManagementDetailCancelDeviceRenewModal
          isVisible={isModalCancelDeviceRenewVisible}
          handleOk={handleCancelDeviceRenewOk}
          handleCancel={handleDeviceRenewCancel}
          vehicleId={vehicleManagmentItem.vehicleId}
          vehicleDetailId={selectedVehicleDetailId}
          providerType={vehicleManagmentItem.providerType}
          onlyDelete={selectedOnlyDelete}
        />
      </div>
    </div>
  );
};

VehicleDeviceOperations.propTypes = {
  vehicleListDetailDeviceTypes: PropTypes.arrayOf(PropTypes.object),
  vehicleManagmentItem: PropTypes.object,
  deviceTypeId: PropTypes.number,
  detailListCount: PropTypes.number,
};

export default VehicleDeviceOperations;
